<template>
  <div>
    <finance-drawer
      title="账单明细"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="`${detailInfo.businessName || ''}（${detailInfo.billNo || ''}）`"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation" class="flex items-center">
        <page-export-button
          v-if="$has('BBZQGL-KHZDGL-XZ')"
          buttonText="下载"
          exportType="button"
          exportServe="fin_ap_bill_export"
          :total="total"
          :isLimit="true"
          :exportParams="{ billNo: detailInfo.billNo || '' }"
          trackCode='baibuBillBillList-4'
          :buttonClass="['table-button', 'table-button-primary']"
          plain
          buttonType="default"
        />
        <el-button
          class="table-button table-button-primary"
          v-track trackCode='baibuBillBillList-3'
          v-if="$has('BBZQGL-KHZDGL-TZ') && detailInfo.billStatus === 'NOT_REPAID'"
          @click="handleOperateState()"
        > 调账 </el-button>
      </div>
      <div v-loading="loading" ref="billDetailRef" style="height: 100%;">
        <div style="margin-bottom: 16px;" ref="billDetailHeaderRef">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            @search="handleSearch"
            @reset="handleOpen"
            trackCode='baibuBillDisburseList-1'
          >
            <template #applyTypeSlotName>
              <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
            </template>
          </jr-search2>
        </div>
        <jr-table
          :height="tableHeight"
          :tableData="list"
          :tableColumn="tableColumn"
          ref="baibuBillDetailTableRef"
        >
          <!-- 流水类型: RECEIPT 支用流水,REFUND 退款流水 -->
          <template #applyTypeSlotName="{row}">
            <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.applyTypeDesc}}</span>
          </template>
          <!-- 收款单金额 -->
          <template #receiptAmountSlotName="{row}">
            <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.receiptAmount | toFenThousandsAndFloat}}</span>
          </template>
        </jr-table>
        <div class="flex flex-justify-end" style="margin-top: 15px" ref="billDetailFooterRef">
          <pagination
            :total="total"
            :current-page="queryForm.page"
            :size="queryForm.limit"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </finance-drawer>

    <!-- 调账 -->
    <account-adjustment-dialog
      :visible.sync="isAccountAdjustmentShow"
      :detailInfo="accountAdjustmentInfo"
      :billNo="accountAdjustmentInfo.billNo"
      @isSetBill="handleIsSetBill"
    />
  </div>
</template>
<script>
import { getBillDetailList } from '@/api/baibu-bill';
import { getMonthDate } from '@/utils/date';
import NP from 'number-precision';
import { setStatusColor } from '@/filters/index';
import accountAdjustmentDialog from './account-adjustment-dialog';

const queryFormDefault = {
  timeType: '1', // 时间类型
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  applyType: '', // 流水类型: RECEIPT 支用流水,REFUND 退款流水
  billNo: '', // 账单编号
  searchContent: '', // 搜索内容-不支持模糊查询,批量查询时以逗号分隔
  searchType: '1', // 搜索类型：1-客户名称,2-客户编号,3-财务客户编号

  searchBatchContent: '', // 处理批量查询时-搜索内容
  searchBatchType: '1', // 处理批量查询时-搜索类型
};

export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    billNo: {
      type: String,
      default: '',
    },
  },
  components: { accountAdjustmentDialog },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      tableHeight: 'auto',
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            { value: '1', label: '业务订单编号' },
            { value: '2', label: '收款单编号' },
            { value: '3', label: '申请编号' },
          ],
        },
        { slot: 'applyTypeSlotName' },
      ],
      selectList: [
        {
          title: '流水类型',
          prop: 'applyType',
          dictionaryPath: '/finance/finance-receipt/ApApplyTypeEnum',
        },
      ],
      tableColumn: [
        { prop: 'receiptNo', label: '收款单编号', minWidth: '1' },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'applyNo', label: '申请编号', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'applyType', label: '流水类型', minWidth: '1', slotName: 'applyTypeSlotName' },
        { prop: 'receiptAmount', label: '收款单金额', slotName: 'receiptAmountSlotName' },
        // 回款状态: NOT_REPAID 未回款,FULLY_REPAID 已回款
        { label: '回款状态', status: 'repaymentStatus', statusDesc: 'repaymentStatusDesc', statusColor: (val) => setStatusColor(val, 'repaymentStatus') },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'createUser', label: '申请人', minWidth: '1' },
      ],

      /** ------调账---- */
      isAccountAdjustmentShow: false,
      accountAdjustmentInfo: {},
    };
  },
  computed: {
    // 收款单金额为负，且高亮展示；
    isTextRed() {
      return (val) => {
        if (val && val < 0) {
          return true;
        }
        return false;
      };
    },
  },
  watch: {
    billNo: {
      deep: true,
      handler() {
        if (this.billNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
    tableHeight() {
      if (this.$refs.baibuBillDetailTableRef) {
        this.$nextTick(() => {
          this.$refs.baibuBillDetailTableRef.doLayout();
        });
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.computedContentHeight, false);
  },
  // 离开页面后的逻辑处理
  destroyed() {
    // 在组件或者页面卸载的地方删除监听
    window.removeEventListener('resize', this.computedContentHeight);
  },
  methods: {
    // 是否调账
    handleIsSetBill(isSetBill) {
      if (isSetBill) {
        this.getList();
      }
    },
    // 打开调账弹窗
    handleOperateState() {
      this.accountAdjustmentInfo = JSON.parse(JSON.stringify(this.detailInfo || {}));
      this.isAccountAdjustmentShow = true;
    },
    // 计算内容高度
    computedContentHeight() {
      this.$nextTick(() => {
        const { billDetailRef, billDetailHeaderRef, billDetailFooterRef } = this.$refs;
        let boxH = 0;
        let headerH = 0;
        let footerH = 0;
        if (billDetailRef) {
          boxH = billDetailRef.clientHeight || 0;
        }
        if (billDetailHeaderRef) {
          headerH = billDetailHeaderRef.clientHeight || 0;
        }
        if (billDetailFooterRef) {
          footerH = billDetailFooterRef.clientHeight || 0;
        }
        const h = NP.minus(boxH, headerH, footerH, 32);
        this.tableHeight = h && h > 0 ? h : 'auto';
        console.log('=========', boxH, '++++++++', headerH, '------', footerH);
        console.log('=tableHeight========', this.tableHeight);
      });
    },
    // 重置时间的默认值
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 处理提交接口的参数（列表/导出）
    newAPiParam() {
      const params = JSON.parse(JSON.stringify(this.queryForm));
      // 批量查询条件处理
      if (this.isBatch) {
        params.searchContent = params.searchBatchContent || '';
        params.searchType = params.searchBatchType || '';
      }
      delete params.timeType;
      delete params.searchBatchContent;
      delete params.searchBatchType;
      return params;
    },
    // 列表接口请求
    async getList() {
      try {
        const params = this.newAPiParam();
        this.loading = true;
        this.list = [];
        const res = await getBillDetailList({ ...params, billNo: this.billNo });
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 打开窗口前-重置搜索条件
    handleOpen() {
      this.$nextTick(() => {
        this.computedContentHeight();
        this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
        this.resetDate();
        this.getList();
      });
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
::v-deep {
  .drawer-body {
    height: 100%;
  }
}
</style>

